import React, { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import styles from './styles.module.scss';
import useResponsiveQuery from 'utils/useResponsiveQuery';
import { SUBSCRIPTION_PLANS_PAGE } from 'components/constants';

import { ScrollTrigger } from 'gsap/ScrollTrigger';

import cardsImageSrc from 'assets/images/new-home-page/cards.png';
import integrationsImageSrc from 'assets/images/new-home-page/integrations.png';

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.addEventListener('refresh', function () {
  if (document.body.getAttribute('style') === '') {
    document.body.removeAttribute('style');
  }
});

function HeadlineSection({ innerRef }: any) {
  const isMobile = useResponsiveQuery();
  const videoRef = useRef<HTMLVideoElement>(document.createElement('video'));
  const [mute, setMute] = useState(true);
  const titleContent = 'Turning generative power into structured, brand-aligned enterprise products';
  const integrationsRef = useRef<HTMLDivElement | null>(null);
  const cardsRef = useRef<HTMLDivElement | null>(null);

  const paragraphContent =
    'Storycards is creating a blue ocean for enterprises that need the power of AI and no-code — within a framework of compliance, collaboration, and measurable impact. Every creation is structured, secure, and fully aligned with your brand DNA.';
  const title = 'No-code platform for engaging data collection';
  const subtitle =
    'Built for enterprises — helping teams collect data, drive engagement, and stay fully on-brand. In a world of unpredictable prompts, Storycards brings structure — turning generative AI into measurable, brand-safe digital products.';

  // useEffect(() => {
  //   const [leftItem, rightItem] = [cardsRef.current, integrationsRef.current];
  //   const toggleActions = 'play none none reverse';
  //   const [enter, leave] = [
  //     { opacity: 1, y: 0 },
  //     { opacity: 0, y: 50 },
  //   ];
  //   gsap.set([leftItem, rightItem], leave);

  //   const tl1 = gsap.to(leftItem, {
  //     scrollTrigger: {
  //       trigger: leftItem,
  //       start: 'center bottom',
  //       end: 'bottom top',
  //       toggleActions,
  //     },
  //     ...enter,
  //     duration: 1,
  //     ease: 'power3.inOut',
  //   });

  //   const tl2 = gsap.to(rightItem, {
  //     scrollTrigger: {
  //       trigger: rightItem,
  //       start: 'bottom bottom',
  //       end: 'bottom top',
  //       toggleActions,
  //     },
  //     ...enter,
  //     duration: 0.75,
  //     ease: 'power1.inOut',
  //   });

  //   return () => {
  //     tl1.kill();
  //     tl2.kill();
  //   };
  // }, []);

  return (
    <section ref={innerRef} className={`${styles.headlineSection} flex flex-col w-full items-center`}>
      <div className={styles.textTop}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.subtitleWrapper}>
          <div className={styles.subtitle}>{subtitle}</div>
          <a href={SUBSCRIPTION_PLANS_PAGE} className={styles.packagesBtn}>
            Get Started →
          </a>
        </div>
      </div>
      <div className={`${styles.videoContainer}`}>
        <video
          playsInline
          autoPlay
          ref={videoRef}
          loop
          muted={mute}
          disableRemotePlayback
          src={`https://assts.stories.sc/website/${isMobile ? 'mobile' : 'desktop'}/main_top.mp4`}
          className={mute ? styles.videoMuteCursor : styles.videoUnmuteCursor}
          onClick={() => setMute(!mute)}
          poster="https://assts.stories.sc/website/poster/maintop.jpg"
        />
        <div className={styles.cardsWrapper} ref={cardsRef}>
          <img src={cardsImageSrc} alt="cards" />
        </div>
        <div className={styles.integarationsWrapper} ref={integrationsRef}>
          <img src={integrationsImageSrc} alt="integrations" />
        </div>
      </div>

      <div
        className={`${styles.content} flex flex-col md:flex-row items-center md:items-start text-center md:text-left`}
      >
        <h3>{titleContent}</h3>
        <p>{paragraphContent}</p>
      </div>
    </section>
  );
}

export default HeadlineSection;
